module.exports = " <span class=modifier v-if=isNonZero(choice.srp_amount) _v-4136c996=\"\"> ({{ asCurrency(choice.srp_amount) }}) </span> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-4136c996!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PriceModifier.vue
// module id = 380
// module chunks = 2